// Funzione per calcolare la classifica finale dopo eliminazione diretta
// standingsGirone: array classifica dopo girone (già ordinata)
// bracket: array rounds (round[0]=quarti, round[1]=semifinali, round[2]=finale)
export function calcolaClassificaFinale(standingsGirone, bracket) {
  if (!bracket || bracket.length === 0) return standingsGirone;

  // Helper: trova team completo dato il nome
  const getTeamCompleto = (team) => {
    if (!team || !team.name) return team;
    return standingsGirone.find(t => t.name === team.name) || team;
  };

  // 1. Trova i finalisti
  const finale = bracket[bracket.length - 1]?.[0];
  if (!finale) return standingsGirone;
  const vincitore = finale.winner === 1 ? getTeamCompleto(finale.team1) : getTeamCompleto(finale.team2);
  const secondo = finale.winner === 1 ? getTeamCompleto(finale.team2) : getTeamCompleto(finale.team1);

  // 2. Trova semifinalisti (i terzi classificati)
  const semifinali = bracket[bracket.length - 2] || [];
  const semifinalisti = semifinali.map(m => {
    // Match valido con entrambi i team
    if (!m.team1 || !m.team2 || m.team1.name === 'TBD' || m.team2.name === 'TBD') {
      return null;
    }

    // Identifica squadra perdente nella semifinale
    // Se il match ha un vincitore determinato
    if (m.completed && m.winner) {
      const loser = m.winner === 1 ? m.team2 : m.team1;
      // Verifica che il perdente non sia finalista (caso raro ma possibile)
      if (loser.name !== vincitore.name && loser.name !== secondo.name) {
        return getTeamCompleto(loser);
      }
    }
    // Se non c'è un vincitore chiaro, controlla chi dei due non è arrivato in finale
    else {
      if (m.team1.name !== vincitore.name && m.team1.name !== secondo.name && m.team1.name !== 'BYE') {
        return getTeamCompleto(m.team1);
      }
      if (m.team2.name !== vincitore.name && m.team2.name !== secondo.name && m.team2.name !== 'BYE') {
        return getTeamCompleto(m.team2);
      }
    }
    return null;
  }).filter(Boolean);

  // 3. Trova quarti di finale
  const quarti = bracket[bracket.length - 3] || [];
  let quartisti = quarti.map(m => {
    // Saltalo se è un match non valido o incompleto
    if (!m.team1 || !m.team2 || m.team1.name === 'TBD' || m.team2.name === 'TBD') {
      return null;
    }

    // Verifica che chi ha perso non sia arrivato in semifinale o finale
    // Otteniamo i nomi di chi è arrivato in semifinale
    const nomiSemifinali = semifinali.flatMap(sf =>
      [sf.team1?.name, sf.team2?.name].filter(n => n && n !== 'TBD' && n !== 'BYE')
    );

    // Se il match ha un vincitore
    if (m.completed && m.winner) {
      const loser = m.winner === 1 ? m.team2 : m.team1;
      // Verifica che il perdente non sia tra chi è arrivato in semifinale o in finale
      if (!nomiSemifinali.includes(loser.name) &&
        loser.name !== vincitore.name &&
        loser.name !== secondo.name &&
        loser.name !== 'BYE') {
        return getTeamCompleto(loser);
      }
    }
    return null;
  }).filter(Boolean);
  // Ordina quartisti secondo la classifica girone
  quartisti = quartisti.sort((a, b) => {
    const posA = standingsGirone.findIndex(t => t.name === a.name);
    const posB = standingsGirone.findIndex(t => t.name === b.name);
    return posA - posB;
  });

  // 4. Costruisci array classifica finale
  const finaleArr = [];

  // Primo e secondo posto
  if (vincitore) finaleArr.push({ ...vincitore, posizione: 1 });
  if (secondo) finaleArr.push({ ...secondo, posizione: 2 });

  // Terzo posto (i due semifinalisti)
  semifinalisti.forEach(s => {
    if (s) finaleArr.push({ ...s, posizione: 3 });
  });

  // Quinto posto (i quartisti)
  // Non saltiamo posizioni, dopo i semifinalisti (che sono in posizione 3)
  // la prossima posizione deve essere 3 + numero_semifinalisti
  const numSemi = Array.isArray(semifinalisti) ? semifinalisti.length : 0;
  const posizioneQuartisti = 3 + numSemi;
  quartisti.forEach((q, i) => {
    if (q) finaleArr.push({ ...q, posizione: posizioneQuartisti + i });
  });

  // Aggiungi anche i team che non hanno partecipato alle eliminatorie, ma sono nei gironi
  // con posizioni consecutive dopo l'ultimo quartista
  const posizioniValide = finaleArr.map(t => Number(t.posizione)).filter(p => !isNaN(p));
  const ultimaPosizione = posizioniValide.length > 0 ? Math.max(...posizioniValide) : 0;

  const teamNonEliminatorie = standingsGirone.filter(team =>
    !finaleArr.some(t => t.name === team.name)
  );

  // Aggiungi i team rimanenti con posizioni consecutive
  teamNonEliminatorie.forEach((team, idx) => {
    if (team) {
      finaleArr.push({
        ...team,
        posizione: ultimaPosizione + 1 + idx
      });
    }
  });

  // Restituisci TUTTI i team, non solo quelli che hanno partecipato alle eliminatorie
  return finaleArr;
}
